import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { searchAccounts as searchAccountsApi, getExactAccount } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { ACCOUNT_RETRIEVAL_FAILED, TEMPORARILY_UNAVAILABLE } from './constants'
import { clearAccountDetails } from './clearAccountDetails'
import { History } from 'history'
import { RoutesEnum } from '../types/RoutesEnum'
import { isPrimitiveEmpty } from '../containers/ApexLogin'
import { clearAccountSearch } from './clearAccountSearch'

export const SEARCH_ACCOUNTS = 'SEARCH_ACCOUNTS'
export const SEARCH_ACCOUNTS_SUCCESS = 'SEARCH_ACCOUNTS_SUCCESS'
export const SEARCH_ACCOUNTS_FAILURE = 'SEARCH_ACCOUNTS_FAILURE'

export const searchAccounts = (
  dispatch: Dispatch,
  searchTerm: string,
  history: History
) => {
  const pathname = history.location.pathname.split('/')[1]
  dispatch({ type: SEARCH_ACCOUNTS, searchTerm })
  clearAccountDetails(dispatch)
  searchAccountsApi(searchTerm)
    .then(({ data: accountResults }: AxiosResponse) => {
      dispatch({ type: SEARCH_ACCOUNTS_SUCCESS, accountResults })
      if (
        accountResults.length === 1 &&
        searchTerm.toUpperCase() ===
          accountResults[0].accountNumber.toUpperCase()
      ) {
        const accountNumber = accountResults[0]?.accountNumber
        if (!isPrimitiveEmpty(accountNumber)) {
          clearAccountSearch(dispatch)
          history.push(`/${pathname}/${accountNumber}`)
        }
      } else {
        history.push(
          `/${RoutesEnum.AccountSummary}?q=${encodeURIComponent(searchTerm)}`
        )
      }
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      // Recommended to not use query param for exact searches; will result in 403
      if (httpResponseStatus === 403) {
        // uses direct path, not query param
        getExactAccount(searchTerm)
          .then(({ data: accountResults }: AxiosResponse) => {
            dispatch({ type: SEARCH_ACCOUNTS_SUCCESS, accountResults })
            const accountNumber = accountResults[0]?.accountNumber
            if (!isPrimitiveEmpty(accountNumber)) {
              clearAccountSearch(dispatch)
              history.push(`/${pathname}/${accountNumber}`)
            }
          })
          .catch((error: ApexApiError) => {
            const errorMessage =
              error.response?.status &&
              error.response?.status >=
                HttpResponseStatusCodes.InternalServerError
                ? TEMPORARILY_UNAVAILABLE
                : ACCOUNT_RETRIEVAL_FAILED
            dispatch({ type: SEARCH_ACCOUNTS_FAILURE, errorMessage })
          })
        return
      }
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : ACCOUNT_RETRIEVAL_FAILED
      dispatch({ type: SEARCH_ACCOUNTS_FAILURE, errorMessage })
    })
}
